import React from "react";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@mui/material/Button";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@mui/material/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import PropTypes from "prop-types";
import Config from "conFig.js";
import { Error, Success } from "../../../assets/jss/util/messageUtil";

const Capnhatbenxe = React.memo(function Capnhatbenxe(props) {
  const { benxe_id } = props;
  const [tinhthanh, setTinhthanh] = React.useState([]);
  const [tinhthanhvalue, setTinhthanhvalue] = React.useState(null);
  const [ten, setTen] = React.useState("");
  const [diachi, setDiachi] = React.useState("");
  const [sodienthoai, setSodienthoai] = React.useState("");
  const [xaphuong, setXaphuong] = React.useState([]);
  const [xaphuongvalue, setXaphuongvalue] = React.useState(0);
  const [loaibenxe, setLoaibenxe] = React.useState(3);
  const [disableBT, setDisableBT] = React.useState(false);
  const [alert, setAlert] = React.useState(false);
  const [alert1, setAlert1] = React.useState(false);
  const [alertValidate, setAlertValidate] = React.useState(false);
  const [messageValidate, setMessageValidate] = React.useState("");
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const gettinhthanh = () => {
    var url = Config.backend + "/api/Diaphuong/gettinh?username=" + username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setTinhthanh(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const getbenxetheoid = () => {
    var url =
      Config.backend +
      "/api/Donvi/getbenxetheoid?id=" +
      benxe_id +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setTinhthanhvalue({ id: data[0].tinh_id, ten: data[0].tinh });
        getxaphuongtheotinh(data[0].tinh_id);
        //setHuyenvalue({ id: data[0].huyentp_id, ten: data[0].huyen });
        setTen(data[0].ten);
        setDiachi(data[0].diachi);
        if (data[0].sodienthoai) setSodienthoai(data[0].sodienthoai);
        setLoaibenxe(data[0].dmloaidonvi_id);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const getxaphuongtheotinh = (id) => {
    var url =
      Config.backend +
      "/api/Donvi/getpxtheotinh?tinh=" +
      id +
      "&username" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setXaphuong(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const loaibenxeChange = (event) => {
    setLoaibenxe(event.target.value);
  };
  const capnhatbenxe = () => {
    let mess = validateCapnhat();
    if (mess === Success.SC0001) {
      var url = Config.backend + "/api/Phuongtien/capnhatbenxe";
      fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json, text/plain",
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          id: benxe_id,
          tinh_id: tinhthanhvalue.id,
          ten: ten,
          //huyentp_id: huyenvalue.id,
          diachi: diachi,
          sodienthoai: sodienthoai,
          dmloaidonvi_id: loaibenxe,
          username: username,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data === 1) {
            showNotification();
          } else showNotification1();
        })
        .catch((error) => {
          console.error("Error fetching data: ", error);
        });
    } else {
      setMessageValidate(mess);
      showNotificationValidate();
    }
  };
  const showNotificationValidate = () => {
    setAlertValidate(true);
    setTimeout(function () {
      setAlertValidate(false);
    }, 6000);
  };
  const showNotification = () => {
    setAlert(true);
    setTimeout(function () {
      setAlert(false);
    }, 2000);
  };
  const showNotification1 = () => {
    setAlert1(true);
    setTimeout(function () {
      setAlert1(false);
    }, 2000);
  };
  const validateCapnhat = () => {
    // Kiem tra cac truong bat buoc nhap
    if (!tinhthanhvalue || tinhthanhvalue.id === 0) {
      return Error.ER0009;
    }
    if (!xaphuongvalue || xaphuongvalue.id === 0) {
      return Error.ER0010;
    }
    return Success.SC0001;
  };
  React.useEffect(() => {
    gettinhthanh();
    getbenxetheoid();
  }, []);
  return (
    <div>
      <CardBody style={{ borderBottom: "1px solid #bbb" }}>
        <GridContainer style={{ marginTop: 1 }}>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%" }}>
              <Autocomplete
                freeSolo
                disableClearable
                size="small"
                value={tinhthanhvalue}
                getOptionSelected={(option, value) => option.id === value.id}
                options={tinhthanh}
                getOptionLabel={(option) => option.ten}
                onChange={(event, value) => {
                  setTinhthanhvalue(value);
                  setXaphuongvalue(null);
                  getxaphuongtheotinh(value.id);
                }}
                onInputChange={(event, newInputValue, reason) => {
                  if (reason !== "reset") {
                    setTinhthanhvalue(null);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Chọn tỉnh thành"
                    InputLabelProps={{
                      sx: {
                        color: "red",
                      },
                    }}
                    InputProps={{
                      ...params.InputProps,
                      type: "search",
                      style: {
                        height: "37px",
                        paddingTop: "initial",
                      },
                    }}
                  />
                )}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%" }}>
              <Autocomplete
                freeSolo
                disableClearable
                size="small"
                value={xaphuongvalue}
                getOptionSelected={(option, value) => option.id === value.id}
                options={xaphuong}
                getOptionLabel={(option) => option.ten || ""}
                onChange={(event, value) => {
                  setXaphuongvalue(value);
                  setDisableBT(false);
                }}
                onInputChange={(event, newInputValue, reason) => {
                  if (reason !== "reset") {
                    setXaphuongvalue(null);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Chọn Huyện/TP"
                    InputLabelProps={{
                      sx: {
                        color: "red",
                      },
                    }}
                    InputProps={{
                      ...params.InputProps,
                      type: "search",
                      style: {
                        height: "35px",
                        paddingTop: "initial",
                      },
                    }}
                  />
                )}
              />
            </FormControl>
          </GridItem>
        </GridContainer>
        <GridContainer style={{ marginTop: 15 }}>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%" }}>
              <TextField
                label="Tên bến xe"
                variant="outlined"
                value={ten}
                size="small"
                onChange={(event) => {
                  setTen(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%" }}>
              <TextField
                label="Địa chỉ"
                variant="outlined"
                value={diachi}
                size="small"
                onChange={(event) => {
                  setDiachi(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
        </GridContainer>
        <GridContainer style={{ marginTop: 15 }}>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%" }}>
              <TextField
                label="Số điện thoại"
                variant="outlined"
                size="small"
                value={sodienthoai}
                onChange={(event) => {
                  setSodienthoai(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%" }}>
              <InputLabel style={{ marginTop: "-8px" }}>Loại bến xe</InputLabel>
              <Select
                value={loaibenxe}
                onChange={loaibenxeChange}
                size="small"
                style={{ height: 35 }}
              >
                <MenuItem value={3}>Bến xe khách</MenuItem>
                <MenuItem value={8}>Bến xe hàng</MenuItem>
              </Select>
            </FormControl>
          </GridItem>
        </GridContainer>
      </CardBody>
      {/** fix css */}
      <CardFooter style={{ marginBottom: "20px" }}>
        <Button
          color="primary"
          variant="contained"
          style={{ height: 27 }}
          disabled={disableBT}
          onClick={capnhatbenxe}
        >
          Cập nhật
        </Button>
      </CardFooter>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="info"
            icon={AddAlert}
            message="Cập nhật thành công"
            open={alert}
            closeNotification={() => setAlert(false)}
            close
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message="Có lỗi trong quá trình cập nhật"
            open={alert1}
            closeNotification={() => setAlert1(false)}
            close
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message={messageValidate}
            open={alertValidate}
            closeNotification={() => setAlertValidate(false)}
            close
          />
        </GridItem>
      </GridContainer>
    </div>
  );
});

Capnhatbenxe.propTypes = {
  benxe_id: PropTypes.number,
};
export default Capnhatbenxe;
